export default __webpack_public_path__ + "static/media/6.af33f3ea.jpg";